import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DeepReactive } from '@jack-henry/frontend-utils/lit';
import { Wire, WireTemplate, WireType } from '@treasury/domain/wires';
import { TmBaseComponent, TmFooterService } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { WireAction, WireWorkflow } from '../../types/wire-workflow-parameters.type';
import './wire-template-editable';

export const tagName = 'wire-template-edit-step';
@customElement(tagName)
export class WireTemplateEditStep extends TmBaseComponent {
    @InjectProperty()
    declare private readonly footerService: TmFooterService;

    @state()
    private wire?: Wire;

    @state()
    private wireTemplate?: WireTemplate;

    @state()
    private action = '' as WireAction;

    @state()
    private workflow = '' as WireWorkflow;

    @state()
    private wireType = WireType.Domestic;

    @DeepReactive()
    private validState = {
        templateName: false,
        creditor: false,
        wireCompany: false,
        debitAccount: false,
        purpose: false,
    };

    protected firstUpdated() {
        this.configureFooter();
    }

    protected render() {
        return html`<wire-template-editable
            class="h-screen"
            .wire=${this.wire}
            .wireTemplate=${this.wireTemplate}
            .wireType=${this.wireType}
            .action=${this.action}
            .workflow=${this.workflow}
            @update=${({ detail }: CustomEvent) => {
                this.wireTemplate = detail.wireTemplate;
                this.checkValidState();
            }}
        ></wire-template-editable>`;
    }

    private configureFooter() {
        this.footerService.configure({
            direction: 'column',
            buttonConfig: [
                {
                    text: 'Review',
                    disabled: Object.values(this.validState).some(isValid => !isValid),
                    onClick: () => {
                        this.dispatchEvent(
                            new CustomEvent('review', { detail: this.wireTemplate })
                        );
                    },
                },
            ],
        });
    }

    private checkValidState() {
        if (this.wireTemplate) {
            this.validState.templateName = !!this.wireTemplate?.name;
            this.validState.creditor = !!this.wireTemplate?.beneficiary.id;
            this.validState.wireCompany = !!this.wireTemplate?.wireCompany.id;
            this.validState.debitAccount = !!this.wireTemplate?.debitAccount.id;
            this.validState.purpose = !!this.wireTemplate?.purpose?.length;
        }
        this.configureFooter();
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireTemplateEditStep;
    }
}
